/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Form base type

Values: 0=Co2, 1=EuTaxonomy, 2=CsobCommercialRealityAsset, 3=CsobEnergyAsset, 4=CsobClient, 5=TMobile, 6=Custom, 7=CsobSupplier, 8=ESRS, 9=TMobileSupplier, 10=BRSR, 11=VSME, 12=CsobSk, 13=ProcurementSupplier
 * @export
 * @enum {number}
 */

export enum FormBaseType {
    Co2 = 0,
    EuTaxonomy = 1,
    CsobCommercialRealityAsset = 2,
    CsobEnergyAsset = 3,
    CsobClient = 4,
    TMobile = 5,
    Custom = 6,
    CsobSupplier = 7,
    ESRS = 8,
    TMobileSupplier = 9,
    BRSR = 10,
    VSME = 11,
    CsobSk = 12,
    ProcurementSupplier = 13
}


